import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_CaptchaDialog = _resolveComponent("CaptchaDialog")!
  const _component_DevDebug = _resolveComponent("DevDebug")!
  const _component_el_config_provider = _resolveComponent("el-config-provider")!

  return (_openBlock(), _createBlock(_component_el_config_provider, { locale: _ctx.locale }, {
    default: _withCtx(() => [
      _createVNode(_component_router_view),
      _createVNode(_component_CaptchaDialog),
      (!_ctx.IS_PRODUCTION)
        ? (_openBlock(), _createBlock(_component_DevDebug, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["locale"]))
}